<template>
  <b-card class="rounded-0">
    <h4>{{ $t('message.signUpContactPersonRejected.title') }}</h4>
    <p v-html="message"></p>
  </b-card>
</template>

<script>
  export default {
    name: 'SignUpContactPersonRejected',
    created () {
      if (Object.keys(this.invitation).length === 0) {
        this.$router.replace('/')
      }
    },
    computed: {
      invitation () {
        return this.$store.getters.invitation
      },
      message () {
        return this.$t('message.signUpContactPersonRejected.message')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/auth/SignUpContactPersonRejected.vue